import React from 'react';
import {
  ShoppingBagIcon,
  ClockIcon,
  ArrowsRightLeftIcon,
  SparklesIcon,
  TagIcon,
  UserIcon,
  CubeTransparentIcon
} from '@heroicons/react/24/outline';

const BADGE_TYPES = {
  sale: {
    icon: ShoppingBagIcon,
    text: 'For Sale',
    className: 'bg-brand-teal/10 text-brand-teal'
  },
  rent: {
    icon: ClockIcon,
    text: 'For Rent',
    className: 'bg-brand-orange/10 text-brand-orange'
  },
  swap: {
    icon: ArrowsRightLeftIcon,
    text: 'Open to Swap',
    className: 'bg-purple-100 text-purple-600'
  },
  designer: {
    icon: SparklesIcon,
    text: 'Designer',
    className: 'bg-pink-100 text-pink-600'
  },
  virtual: {
    icon: CubeTransparentIcon,
    text: 'Virtual',
    className: 'bg-indigo-100 text-indigo-600'
  },
  sharing: {
    icon: UserIcon,
    text: 'Closet',
    className: 'bg-yellow-100 text-yellow-600'
  },
  others: {
    icon: TagIcon,
    text: 'Service',
    className: 'bg-gray-100 text-gray-600'
  },
  concept: {
    icon: SparklesIcon,
    text: 'Display Only',
    className: 'bg-blue-100 text-blue-600'
  }
};

const Badge = ({
  type,
  text: customText,
  className: customClassName = '',
  size = 'base', // 'sm', 'base', or 'lg'
  color // Add new color prop
}) => {
  const badge = BADGE_TYPES[type] || {};
  const Icon = badge.icon;
  const text = customText || badge.text;

  // Map color prop to Tailwind classes
  const colorClasses = {
    gray: 'bg-gray-100 text-gray-600',
    red: 'bg-red-100 text-red-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    green: 'bg-green-100 text-green-800',
    blue: 'bg-blue-100 text-blue-800',
    indigo: 'bg-indigo-100 text-indigo-800',
    purple: 'bg-purple-100 text-purple-800',
    pink: 'bg-pink-100 text-pink-800',
    teal: 'bg-teal-100 text-teal-800', // Added Teal
    orange: 'bg-orange-100 text-orange-800' // Added Orange
  };

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    base: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const iconSizes = {
    sm: 'h-3.5 w-3.5',
    base: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 rounded-full font-medium
        ${customClassName || colorClasses[color] || badge.className || colorClasses.gray} // Prioritize customClass, then color, then type, then gray
        ${sizeClasses[size]}
      `}
    >
      {Icon && <Icon className={iconSizes[size]} />}
      {text}
    </span>
  );
};

export default Badge; 